<template>
    <Dialog v-model:visible="isVisible" header="Create New Work" @hide="hide()" @show="show()" :dismissable="false"
        :draggable="false" :modal="true" :style="{ width: '30vw' }">
        <span v-show="errMessage" class="p-error">{{ errMessage }}</span>

        <div class="mt-3">
            <FormField v-model="changeCompany" labelName="Supply for Company" fieldClass="col-12" labelClass="col-5"
                v-if="requireCompany">
                <CustomSelect v-model="changeCompany.coy"
                    :url="this.$API_URL + 'list/companylinkedIsWilmar_id'" :minLength="0" :filter="true"
                    :params="{companyId : this.companyId}"   @change="changecoy($event)" :disabled="false" />
                <template #error>
                    <small v-if="v$.changeCompany.coy.$error" class="p-error" style="display: block">
                        {{
                            v$.changeCompany.coy.$errors[0].$message.replace(
                                "Value",
                                "Company"
                            )
                        }}
                    </small>
                </template>
            </FormField>
        </div>


        <template #footer>
            <Button type="button" icon="pi pi-save" class="p-button p-button-success" @click="checkCoy()" label="Save" />
        </template>
    </Dialog>
</template>
<script>
import moment from 'moment';
import useVuelidate from "@vuelidate/core";
import { required, minLength, sameAs, requiredIf } from "@vuelidate/validators";

export default {
    data() {
        return {
            v$: useVuelidate(),
            errMessage: null,
            url: this.$API_URL + "work/initwork",
            companyId : this.$store.getters.getCompanyId,
            modelPassword: null,
            username : this.$store.getters.getUsername,
            coyCodeUser : this.$store.getters.getCompanyCode,
            userTimeZoneOffset: moment().utcOffset() / 60,
            timezoneUserOffset: this.$store.getters.getTimezoneOffset,
            userTime: moment().format("HH:mm"),
            coyCodeSupply : null,
            editorPath: "/Work/Editor",
            resetPassword: {
                currentPass: null,
                pass: null,
                confirmPass: null,
            },
             changeCompany: {
                coy: null
            },
        };
    },
    validations() {
        return {
            changeCompany: {
                coy: { required }
            },
        };
    },
    props: {
        model: {
            type: Object,
            default: null,
        },
        userId: {
            type: String,
            default: null,
        },
        isVisible: {
            type: Boolean,
            default: false,
        },
        requireCompany: {
            type: Boolean,
            default: false
        },
        initialErrorMessage: {
            type: String,
            default: ""
        },
        changeFirstLogin: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        show() {
            if (this.initialErrorMessage) {
                this.errMessage = this.initialErrorMessage;
            }
        },
        hide(changeSuccess, message) {
            this.resetPassword = {
                pass: null,
                confirmPass: null,
            };
            this.v$.$reset();
            this.errMessage = null;
            this.$emit("update:isVisible", false);
            this.$emit("hide", {
                success: changeSuccess,
                message: message
            });
        },
        passwordClass(data) {
            if (data.showPassword == undefined) {
                data.showPassword = "pi pi-eye";
            }
            data.showPassword =
                data.showPassword == "pi pi-eye-slash" ||
                    data.showPassword == undefined
                    ? "pi pi-eye"
                    : "pi pi-eye-slash";
            return data.showPassword;
        },
        passwordType(data) {
            return data == "pi pi-eye" ? "pi pi-eye-slash" : "pi pi-eye";
        },
        changecoy(e) {
            //console.log(e)
            this.coyCodeSupply = e == null ? null : e.code;
        },
        checkCoy() {
            this.v$.$validate();

            var self = this;

            if (!this.v$.$error) {
                this.$emit("block-ui");
                this.v$.$reset();

                this.$axios
                    .post(this.url, {
                        mode : this.$FORM_MODE_CREATE,
                        VendorCode : this.coyCodeUser,
                        WorkUser: this.username,
                        CompanyCode: this.coyCodeSupply,
                        TimeZoneOffset: this.timezoneUserOffset,
                    })
                    .then((response) => {
                        if (response.data.success) {
                            //this.$router.push({ path:  "/Work/Editor" , query: { mode: "Edit", id: id } });
                            self.$emit("update:model", this.model);
                            self.hide(true, response.data);
                        } else {
                            this.errMessage = "Failed: " + response.data.message;
                        }
                        this.$emit("unblock-ui");
                    })
                    .catch((err) => {
                        this.$emit("unblock-ui");
                        self.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: err.message,
                            life: 3000,
                        });
                    });
            }
        },
    },
    emits: ["hide", "block-ui", "unblock-ui"],
};
</script>
